import { OpenAPI } from '../../../openapi/core/OpenAPI'
import { request as __request } from '../../../openapi/core/request'

export interface FacebookPageSummary {
  id: string
  name: string
  picture?: string
  /** False when the user can see the Page (e.g. through a Business Portfolio) but has no posting access. */
  canPublish: boolean
  businessName?: string
}

export interface FacebookPagesResponse {
  pages: FacebookPageSummary[]
}

export interface SelectFacebookPageResponse {
  success: boolean
  pageName?: string
}

// Thin handwritten wrappers around the existing server endpoints. The generated
// `IntegrationsService.integrationControllerSelectFacebookPageV1` takes no body
// argument, so we send `{ pageId }` by hand here. Can be replaced with the
// generated calls after running `yarn openapi` against a server that types the
// request body (mirrors linkedin-targets-api.ts).
export const FacebookPagesApi = {
  list(): Promise<FacebookPagesResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v1/integrations/facebook/pages',
    })
  },
  select(body: { pageId: string }): Promise<SelectFacebookPageResponse> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/v1/integrations/facebook/select-page',
      body,
      mediaType: 'application/json',
    })
  },
}
